import React, {useEffect, useState} from "react";
import { InputText } from 'primereact/inputtext';
import { Sidebar } from 'primereact/sidebar';
import { Panel } from 'primereact/panel';
import { Splitter, SplitterPanel } from 'primereact/splitter';

import ProSearchableDropDown from "../../components/waitlist/ProSearchableDropDown";
import ProWaitlistFilter from "../../components/waitlist/ProWaitlistFilter";
import ProWaitlistForm from "../../components/waitlist/ProWaitlistForm";
import ProWaitlistState from "../../components/waitlist/ProWaitlistState";

import useWaitlist from "../../hooks/useWaitlist";
import useFormModelServices from "../../hooks/useFormModelServices";
import useRolePermissionServices from "../../hooks/useRolePermissionServices";
import { useDialogService } from "../../hooks/useDialogService";

import { Severity } from "../../constants/ProConstants";
import _ from 'lodash'

const Waitlist = ()=>{
   
    const [showFilter, setShowFilter] = useState(false); 
    const [formHeader, setFormHeader] = useState("");
    const [toggleSideBar, setToggleSideBar] = useState(false);
    const [nodeModel, setNodeModel] = useState({})
    const [formAction, setFormAction] = useState('')
    
    const {data:{allWaitlist, waitlistClients, isFilterApplied, selectedWaitlist}, actions:{SetSelectedWaitlist, SetSearchValue, RemoveClientWaitlist}} = useWaitlist({refresh:true});
    const {GetWaitlistClient} = useFormModelServices();
    const {actions:{ShowDialog}} = useDialogService();
    const {data:{WaitlistRoles}} = useRolePermissionServices()

    useEffect(()=>{
        if(_.get(allWaitlist, "length") >=0 && (_.isEqual(_.findIndex(allWaitlist, (w)=>_.isEqual(w.id, _.get(selectedWaitlist,"id"))), -1))){
            SetSelectedWaitlist(allWaitlist[0])   
        }
    }, [allWaitlist])

    useEffect(()=>{
        setToggleSideBar(false);
    }, [selectedWaitlist])



    const performAction = async (operation, formTitle, data) => {        
        switch (operation) {
            case "ADD":
                setNodeModel({});
                setFormAction("ADD");
                setFormHeader(formTitle);
                setToggleSideBar(prev=>!prev)
                break;
            case "EDIT":
                setNodeModel(await GetWaitlistClient(data.waitlistAssignmentId));
                setFormAction("EDIT");
                setFormHeader(formTitle);
                setToggleSideBar(prev=>!prev)
                break;
            case "REMOVE":     
                var header =  _.isEmpty(data.client)? `Remove ${data.pendingClientName} from ${selectedWaitlist.name}?`
                                :`Remove ${data.client.lastName}, ${data.client.firstName} from ${selectedWaitlist.name}?`
                var labelOk = "Yes, Remove from Waitlist";
                var labelCancel = "Cancel"
                await ShowDialog(header, null, null, labelOk, labelCancel, Severity.Danger,
                async ()=>{
                    await RemoveClientWaitlist(data.waitlistAssignmentId);                   
                }, 
                ()=>{console.log("Cancel Action")});
            break;  
            case "CANCEL":
                setNodeModel({});
                setFormAction("CANCEL");
                setToggleSideBar(false);               
                break;  
            default:
                break;
            
        }
    }

    return (<div>
        <div className='header-row'>
            <div className="search-box">
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText className='search-bar-input' onChange={(e) => SetSearchValue(e.target.value)} placeholder="Search" />
                </span>
            </div> 
            <div> 
                <ProSearchableDropDown value={selectedWaitlist} options={allWaitlist} onChange={(e)=>SetSelectedWaitlist(e.value)} showClear={false}/>
            </div> 
            <div className='add-btn'>
                {WaitlistRoles.canModifyWaitlistClient &&
                    <div className='btn-plus' onClick={()=>performAction("ADD", "Add to Waitlist")}>
                        <i className="pi pi-plus" /> Add
                    </div>
                }
                <Sidebar dismissable={false} modal={false}
                    visible={toggleSideBar} position="right"
                    style={{ width: '30em' }} onHide={() => setToggleSideBar(false)} icons={() => (
                        <h6 className="p-sidebar-close"
                            style={{ fontWeight: '700', fontSize: '20px', width: '100%', margin: 'auto' }}>{formHeader}</h6>
                    )}>
                    <ProWaitlistForm formModel={nodeModel} formAction={formAction} showFooter={true} closeSideBar={(e) => {performAction("CANCEL") }} />
                </Sidebar>              
            </div>
        </div>
        {showFilter && <div className="p-col-16 p-lg-12">
            <Panel header="Filter Options">
                <ProWaitlistFilter toggleFilter={()=>setShowFilter(prev => !prev)} />
            </Panel>
        </div>}    
        <div>
            <div className='data-row'>              
                <div className="p-col-16 p-lg-12 p-waitlist">                    
                <Splitter  >
                {waitlistClients.map((state, index)=>{                  
                    return <SplitterPanel key = {index} className="p-d-flex p-ai-center p-jc-center"> 
                    <ProWaitlistState state={state} performAction={performAction} />
                 </SplitterPanel>
                })                
                }
                </Splitter>  
                </div>               
            </div>
        </div>
    </div>)


}

export default Waitlist;